import {
  resolveExclusiveAction,
  resolveExclusiveLockTooltip,
} from './liksChatComposerExclusive';
import type {
  LiksChatComposerExclusiveAction,
  LiksChatComposerExclusiveLockLabels,
} from './LiksChatComposer.types';

type ResolveComposerExclusiveUiOptions = {
  hasAttachments: boolean;
  hasLinkedKnowledgeBases: boolean;
  webSearchEnabled: boolean;
  imageGenerationEnabled: boolean;
  exclusiveLockLabels: LiksChatComposerExclusiveLockLabels;
  attachLabel: string;
  addLabel: string;
  webSearchLabel: string;
  imageGenerationLabel: string;
};

export type ComposerExclusiveUi = {
  exclusiveAction: LiksChatComposerExclusiveAction | null;
  isAttachmentsLocked: boolean;
  isKnowledgeLocked: boolean;
  isWebSearchLocked: boolean;
  isImageGenerationLocked: boolean;
  attachmentsTooltip: string;
  knowledgeTooltip: string;
  webSearchTooltip: string;
  imageGenerationTooltip: string;
};

export function resolveComposerExclusiveUi({
  hasAttachments,
  hasLinkedKnowledgeBases,
  webSearchEnabled,
  imageGenerationEnabled,
  exclusiveLockLabels,
  attachLabel,
  addLabel,
  webSearchLabel,
  imageGenerationLabel,
}: ResolveComposerExclusiveUiOptions): ComposerExclusiveUi {
  const exclusiveAction = resolveExclusiveAction({
    hasAttachments,
    hasLinkedKnowledgeBases,
    webSearchEnabled,
    imageGenerationEnabled,
  });
  const isAttachmentsLocked =
    exclusiveAction != null && exclusiveAction !== 'attachments';
  const isKnowledgeLocked =
    exclusiveAction != null && exclusiveAction !== 'knowledge';
  const isWebSearchLocked =
    exclusiveAction != null && exclusiveAction !== 'webSearch';
  const isImageGenerationLocked =
    exclusiveAction != null && exclusiveAction !== 'imageGeneration';

  return {
    exclusiveAction,
    isAttachmentsLocked,
    isKnowledgeLocked,
    isWebSearchLocked,
    isImageGenerationLocked,
    attachmentsTooltip:
      resolveExclusiveLockTooltip(
        'attachments',
        exclusiveAction,
        exclusiveLockLabels,
      ) ?? attachLabel,
    knowledgeTooltip:
      resolveExclusiveLockTooltip(
        'knowledge',
        exclusiveAction,
        exclusiveLockLabels,
      ) ?? addLabel,
    webSearchTooltip:
      resolveExclusiveLockTooltip(
        'webSearch',
        exclusiveAction,
        exclusiveLockLabels,
      ) ?? webSearchLabel,
    imageGenerationTooltip:
      resolveExclusiveLockTooltip(
        'imageGeneration',
        exclusiveAction,
        exclusiveLockLabels,
      ) ?? imageGenerationLabel,
  };
}
